module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#FAF9F5"
    }
  }, [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "schools-posts-area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 schools-posts-area-lf",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "schools-posts-area-lf-m"
  }, _vm._l((_vm.blogList), function(item) {
    return _c('li', {
      class: [_vm.currentBlog.id === item.id ? 'active' : ''],
      on: {
        "click": function($event) {
          return _vm.checkLi(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0), _vm._v(" "), _c('img', {
    staticClass: "schools-posts-area-lf-b",
    attrs: {
      "src": "http://en.sc.ruc.edu.cn/static/images/school/png10.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('h2', {
    staticClass: "blog-detail-tit"
  }, [_vm._v("\n              " + _vm._s(_vm.currentBlog.title) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "blog-detail-img"
  }, [_c('img', {
    staticClass: "img-fluid wow slideInLeft",
    attrs: {
      "src": _vm.currentBlog.img,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-detail-content content-wrap wow slideInRight"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentBlog.content)
    }
  })])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schools-posts-area-lf-t",
    staticStyle: {
      "font-size": "24px",
      "line-height": "28px"
    }
  }, [_vm._v("\n            International Exchange and "), _c('br'), _vm._v("\n            Cooperation Programs")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b9063a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InternationalDetails.vue
// module id = 79
// module chunks = 0